import React, { createContext, useContext, useEffect, useState } from "react";

import LocalStorage from "../managers/LocalStorage";
import authApi from "../services/apis/Auth.Api";
import UserApi from "../services/apis/User.Api";

const authContext = createContext();
export function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
  return useContext(authContext);
};

function useProvideAuth() {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [logoutTimer, setLogoutTimer] = useState(null);

  useEffect(() => {
    const storedUser = LocalStorage.getUser();
    const storedToken = LocalStorage.getToken();
    if (storedUser && storedToken) {
      setUser(storedUser);
      setIsLoggedIn(true);
      startSessionCheck();
    }
  }, []);

  const startSessionCheck = async () => {
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
    try {
      const userData = await UserApi.getUserInformation();
      if (!userData) {
        throw new Error("No valid user data");
      }
    } catch (error) {
      logOut();
      window.location.reload();
      alert("Session expired. Please sign in again.");
    }

    // Check the session every 15 minutes after the initial session check
    const timer = setInterval(async () => {
      try {
        const userData = await UserApi.getUserInformation();
        if (!userData) {
          throw new Error("Session expired");
        }
      } catch (error) {
        logOut();
        window.location.reload();
        alert("Session expired. Please sign in again.");
      }
    }, 900000);
    setLogoutTimer(timer);
  };

  const logOut = async () => {
    LocalStorage.removeUser();
    LocalStorage.removeToken();
    setIsLoggedIn(false);
    setUser(null);
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  };

  const signin = async (credentials) => {
    const response = await authApi.loginUser(credentials);
    if (response.success) {
      setUser(response.user);
      setIsLoggedIn(true);
      LocalStorage.setUser(response.user);
      LocalStorage.setToken(response.token);
      startSessionCheck();
    }

    console.log("Response  in use auth:", response);

    return response;
  };

  const signout = () => {
    logOut();
  };

  return {
    user,
    signin,
    signout,
    isLoggedIn,
  };
}
